import { render, staticRenderFns } from "./PreguntasDinamicas.vue?vue&type=template&id=4ca78697&scoped=true"
import script from "./PreguntasDinamicas.vue?vue&type=script&lang=ts"
export * from "./PreguntasDinamicas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca78697",
  null
  
)

export default component.exports